


























































import {Component, PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {Action} from "vuex-class";
import {PoolFilter} from "@/store/settings/pools/types";
import {NumberWings, InputWings} from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {NumberWings, InputWings}})
export default class PoolsFilter extends BaseFilter<PoolFilter>{
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;

  @Action("getPools") actionGetPools: any;

  defaultFilter(): PoolFilter {
    return {
      name: undefined,
      description: undefined,
      page_number: 1
    }
  }

  created() {
    this.filtered();
    this.scroll();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Page",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetPools(this.filter);
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: PoolsFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
